/* Observership external application: Resend or create Activate token page when activate account failed
 * 
 * Page will display success/fail message for activate token sending result
 * User will receive activate token email if activate is successful
 
 * author: @ch168189
 * created: 08/16/2023
 
 */
 
 import React, {useState,  useRef,  useContext, useEffect} from "react";  
 import ReCAPTCHA from "react-google-recaptcha";
 import {  Formik} from "formik";  
 import InputTxt from "../framework/InputTxt";
 import Button from "../framework/Button";
import Ribbon from "../framework/Ribbon";
 
 import webRootContext from "../components/webrootcontext/WebRootContext";
 import { AppConfiguration } from "../framework/AppConfigProvider";
 
 
  
	
 
 function RequestActivateToken(props)  {

    const localConfig = useContext(AppConfiguration);
    
	const [saveSuccess, setSaveSuccess] = useState();
	const [formikError, setFormikError] = useState();
	const [formSubmitted, setFormSubmitted] = useState();
	const [responseError, setResponseError] = useState("");
	const captchaRef = useRef(null);
	const formRef = useRef(null);
	const verifyRecaptcha_api_url =  webRootContext + "/rest/captchaservice/verifyCaptcha";
	
	const formSuccessMsgTitle = <div>Thank you for registering to the Boston Children’s Hospital Observership Program portal.</div>	;
	const formErrMsgTitle = <div>Sorry,  there was a problem.</div>	;
	const formActivedMsgTitle = <div>Your account has already been activated. </div>
			
	const formActivatedMsgContent =  <div>	               			    										
					 	<div className="padding-bottom-30">You may now <a href="./login">log in</a> and complete your application.</div>			
	           </div>;			    
	const formSuccessMsgContent =  <div>	               			    						
					<div className="padding-bottom-30">
					 	An email has been sent to your email account; please activate your account by clicking the link provided in the email.
					</div>
					<div className="padding-bottom-30"> 
						Please add the Observership Program email address (observership.program@childrens.harvard.edu) to your safe sender list to make sure you receive program communications.
				     </div>
	           </div>;
	const formErrMsgContent =  <div>
					<div className="padding-bottom-30"> 
						Please contact the  <a href="mailto:observership.program@childrens.harvard.edu">Observership Program (observership.program@childrens.harvard.edu)</a> 
				     </div>
	           </div>;   
	const emailErrMsgContent =  <div>
					<div className="padding-bottom-30"> 
					    unable to send the token email.
				     </div>
	           </div>;   
	           
    const checkKeyDown = (e) => {
        if (e.key === 'Enter') e.preventDefault();
    }	                   
	
	window.recaptchaOptions = {
	  useRecaptchaNet: true
	  
	};

	let captChaContent=<div></div>;
	if(localConfig.configProperties.captchaSiteKey!=null){
	  captChaContent = <ReCAPTCHA sitekey={localConfig.configProperties.captchaSiteKey}  ref={captchaRef}  />		
	}	
    
	
	
	function validateEmail(checkemail){
		let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/; // eslint-disable-line

		return reg.test(checkemail.trim());
	}
	
	function ResendActivateToken(token, values, {setFieldError}){
        if(token == null  || token === ""){
            setFormSubmitted(false); 
			setResponseError("Please check Captcha checkbox ");
			
			return;
        }
		
				
		 fetch(verifyRecaptcha_api_url, {
	      	method: 'POST', 
	   		headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
					},
			body: token,
	    	mode:"cors"})
 		    .then((response) => {
				 return response.status;			  
		    })
		    .then((result) => {
			    
			    if(result === 200){
                  GetAccountToken(values, {setFieldError}) ; 
				  
				  
			   }else{
				  setSaveSuccess(-1);
				  setResponseError("verify token failed"); 
				  setFormSubmitted(true); 
		    		
			   }
			   
			   
		  });
		   
	}
	
	function GetAccountToken(values, {setFieldError}) {
        let userEmail = values.userEmail;
        let url = webRootContext + "/rest/usermanagement/sendAccountToken";
         fetch(url, {
	      	method: 'POST', 
	   		headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
					},
			body: userEmail.trim(),
	    	mode:"cors"})
 		    .then((response) => {
                 if (response.ok) {
                     return response.json();
                 }else{
                     setSaveSuccess(-1);  
                     return null
                 }						  
		    })
		    .then(
                (result) => {
                    setSaveSuccess(result);
                    if(result === 0){ 
                        setFormSubmitted(false);
                        setResponseError("REVIEW ISSUES BELOW");
                        setFormikError(true);		
                        	                              	
                        setFieldError('userEmail', 'We could not find an account with that email address');
                   } else if (result === -2){  //email failed to send                      
                        setFormSubmitted(true);
                       
                   } else {                     	
                        setFormSubmitted(true);
                   }
                                       
                }
            )
		    .catch((err) => {
                setSaveSuccess(-1); 
          		console.log("error", err); 
	  		});
        
    }
	
	useEffect(() => {	
        const footerElement = document.querySelector('.footer');
        if (footerElement) {
            footerElement.classList.add("footer_extra")
        }
        
        return () => {
          if (footerElement) {
            footerElement.classList.remove('footer_extra');
          }
        }
    },[]);// eslint-disable-line
	
	
	return (
        <div id="resendtoken" className={ 'show_div'}>
       		  <Formik innerref={formRef} 
			 	initialValues={{	
				 	userEmail: ""
				 }}
				 validateOnChange={false}
			 	validate={values => {
					 const errors = {};		 
				 
				     
				     if (!values.userEmail || values.userEmail.trim().length === 0) {
			           errors.userEmail = 'Email address is required';			           
			         } 
			         
			         
			         			         
			         if(saveSuccess === 0 ) {  
			            
			            errors.userEmail = 'We could not find an account with that email address' ;
			            setSaveSuccess(-1);
			            
			        }
					 
						          
			          if (values.userEmail && (!validateEmail(values.userEmail))){
						errors.userEmail = "Enter a valid email address using this format: example@mail.com.";  
					  }
					  
					 
			          
			         if( Object.keys(errors).length > 0) {
						setFormikError(true);
						setResponseError("REVIEW ISSUES BELOW");
					  } else {
			              setFormikError(false);
			              setResponseError("");
			          }	
	          
			         return errors;
		       }}
			 
			 onSubmit={(values,  { setSubmitting, setFieldError }) => {
						
		          setTimeout(() => {
					  		  
					  	const token = captchaRef.current.getValue();
					  	
          				captchaRef.current.reset();		  	
					  	ResendActivateToken(token, values, {setFieldError});
		          		
                        setSubmitting(false); 	          	    	          		
		          }, 100);
		        }}			 
			 >
			 
			   { ({
		          values /* all data need to run the valdation*/,
		          errors /* all error strings */,
		          touched/* all field touch event  */,
		          handleChange /* value change event handler */,
		          handleBlur /* onBlur event handler */,
		          handleSubmit /* for submit button */,
		          isSubmitting /* for submit button */,
		          isValid /* for submit button */,
		          dirty /* for submit button */,
		          validateForm
		          /* and other goodies */
		        }) => (
				
				 <form onSubmit={handleSubmit} onKeyDown={(e) => checkKeyDown(e)} noValidate>
				   <div id="submitResult" className={(formSubmitted ? 'show_div' : 'hide_div')}>
						<div id="resultDiv" className="div_3_col">
							<Ribbon label={saveSuccess >= 1? "Submitted": "error"} status={saveSuccess>= 1? "checkmark": "error"} subheader={saveSuccess===1? formSuccessMsgTitle: (saveSuccess ===2? formActivedMsgTitle: formErrMsgTitle) } content={saveSuccess===1? formSuccessMsgContent:(saveSuccess === 2 ? formActivatedMsgContent :(saveSuccess === -2 ? emailErrMsgContent: formErrMsgContent) )} />
						</div>
						
				   </div>	
				   
				   <div id="theDiv2Hide5" className="div_3_col">
			          	<div className="breadcrumbLink">
			                <a href="/observership/Login">Login</a>
			            </div>         
			            <div className= {(formSubmitted ? 'hide_div':'show_div page_title')}> Request Activation Token</div>            
		           </div>  
           
				   
				   <div id="formikErrors" className={(formikError || responseError !== "" ? 'show_div' : 'hide_div')}>
		               <div id="formikFailDiv" className="div_1_col">
		               		<Ribbon label={responseError} status={"error"} subheader={""} content={""} />
		               </div>
		          </div>
				 		 
				   	 
				 		 
		 		  <div id="formInputs" className={(formSubmitted ? 'hide_div' : 'show_div' )} >
		 		  	<div className="div_3_col padding-bottom-30"></div>
				 		 			 	
				 	<div className="div_3_col">
					 	<InputTxt
			                id="userEmail" 
			                name="userEmail" 
			                labelText="Email address"      
			                isRequired={true} 
			                errorMessage={errors.userEmail}
			                maxLength={100}        
			                hasError={touched.userEmail && errors.userEmail}                               
			                onChange={handleChange }		               
			                onBlur={handleBlur}             
			              />
		             </div>		 	
		             
		            
		             <div className="div_3_col padding-bottom-30">
		             	{captChaContent}		              
		             </div>
		             
		             <hr className="hr--light" />
		             <div className="div_3_col horizontal_div">
		             
		             <Button
		                text={"Continue"}
		                styleName={"button button--primary"}
		                id={"button_submit"}
		                type="submit"
		                onClick={(e) =>{ validateForm();}}
		              />
		                            
		            </div>
		 		  
		 		  </div>				 			            		             				 	
		        </form>
				 
				 
				 )}
		 </Formik>
       </div>
    )
    };

export default RequestActivateToken;
	